document.addEventListener('DOMContentLoaded', function() {
    const backTopBtn = document.getElementById('back-top');

    if (backTopBtn) {
        // Scroll olayını dinle
        window.addEventListener('scroll', function() {
            if (window.scrollY > 100) {
                backTopBtn.classList.remove('hidden');
                backTopBtn.classList.add('block');
            } else {
                backTopBtn.classList.add('hidden');
                backTopBtn.classList.remove('block');
            }
        });
        
        // Tıklanınca yukarı scroll et
        backTopBtn.querySelector('a').addEventListener('click', function(e) {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    }
});